import React from 'react'
import Layout from '../Layout'
import classnames from 'classnames'

import styles from './styles.module.less'

export default function LayoutContent({ children, padder, rounded, className, isInner = true }) {
  const classNames = classnames(styles.content, className, {
    [styles.padder]: padder,
    [styles.rounded]: rounded,
    [styles.appMainContent]: isInner === false,
  })

  return <Layout className={classNames}>{children}</Layout>
}
